/**
 @author xiaoye
 @date 2020/4/20 11:50 上午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

//Mysql连接测试
let token01 = null;
export const MySqlConnText = async (data) => {
    if (token01) {
        token01.cancel({status: 'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[2] + "/MySqlConnText",
        method: "post",
        data: data,
        token: token01.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//Sqlserver连接测试
let token02 = null;
export const SqlServerConnText = async (data) => {
    if (token02) {
        token02.cancel({status: 'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[2] + "/SqlServerConnText",
        method: "post",
        data: data,
        token: token02.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

// Oracle连接测试
let token03 = null;
export const OraConnText = async (data) => {
    if (token03) {
        token03.cancel({status: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[2] + "/OraConnText",
        method: "post",
        data: data,
        token: token03.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

// Excel连接测试
let token04 = null;
export const ExcelConnTestAsync = async (data) => {
    if (token04) {
        token04.cancel({status: 'cancel'});
    }
    token04 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[2] + "/ExcelConnTestAsync",
        method: "post",
        data: data,
        token: token04.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

// 达蒙连接测试
let token10 = null;
export const DaMengConnText = async (data) => {
    if (token10) {
        token10.cancel({status: 'cancel'});
    }
    token10 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[2] + "/DaMengConnText",
        method: "post",
        data: data,
        token: token10.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

// 金仓连接测试
let token11 = null;
export const KingBaseConnText = async (data) => {
    if (token11) {
        token11.cancel({status: 'cancel'});
    }
    token11 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[2] + "/KingBaseConnText",
        method: "post",
        data: data,
        token: token11.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};
// 保存
let token05 = null;
export const SaveDataSource = async (data) => {
    if (token05) {
        token05.cancel({status: 'cancel'});
    }
    token05 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[3] + "/SaveDataSource",
        method: "post",
        data: data,
        token: token05.token,
        loading: true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//获取当前用户的数据接入列表
let token06 = null;
export const GetDataSourceTableList = async (data) => {
    if (token06) {
        token06.cancel({status: 'cancel'});
    }
    token06 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[3] + "/GetDataSourceTableList?" + qs.stringify(data),
        method: "get",
        token: token06.token,
    })
};

//获取当前用户的数据接入列表
let token07 = null;
export const GetDataSourceByDataSourceId = async (data) => {
    if (token07) {
        token07.cancel({status: 'cancel'});
    }
    token07 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[3] + "/GetDataSourceByDataSourceId?" + qs.stringify(data),
        method: "get",
        token: token07.token,
    })
};

//删除数据接入
let token08 = null;
export const RemoveDataSource = async (data) => {
    if (token08) {
        token08.cancel({status: 'cancel'});
    }
    token08 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[3] + "/RemoveDataSource?" + qs.stringify(data),
        method: "get",
        token: token08.token,
    })
};


//验证同一用户下数据接入名称是否存在
let token09 = null;
export const GetDataSourceNameVerify = async (data) => {
    if (token09) {
        token09.cancel({status: 'cancel'});
    }
    token09 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[3] + "/GetDataSourceNameVerify?" + qs.stringify(data),
        method: "get",
        token: token09.token,
    })
};


